import script from "./MarketplaceReviews.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketplaceReviews.vue?vue&type=script&setup=true&lang=ts"

import "./MarketplaceReviews.vue?vue&type=style&index=0&id=b69986dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b69986dc"]])

export default __exports__